import { TimeInput as MantineTimeInput, type TimeInputProps as MantineTimeInputProps } from '@mantine/dates'
import { type FC } from 'react'

export interface TimeInputProps extends MantineTimeInputProps {}

export const TimeInput: FC<TimeInputProps> = (props) => (
  <MantineTimeInput
    mb='xs'
    radius='md'
    {...props}
  />
)
